module.exports = __webpack_public_path__ + "img/easter_tour_mini_cover_1.0abbc742.png";